/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.20.0
 * @since 1.20.0
 */

import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import map from 'lodash/map';
import mapValues from 'lodash/mapValues';

import { utoa } from '../../../utils/URIEncode';
import { ITableMetaResponse } from '../api/types';

export const mapMetaResponse = (response: ITableMetaResponse): ITableMetaResponse => {
    if (response.filterAndSort?.filter) {
        response.filterAndSort.filter = mapValues(response.filterAndSort?.filter, filter => {
            /* Фильтр нужно закодировать  */
            if (filter?.valuesAsBase64String) {
                /* Кодирование значений мультиселкта */
                if (isArray(filter.value)) {
                    return { value: map(filter.value, (value: string) => utoa(value?.toString())) }
                } else if (isString(filter.value)) { /* Кодирование значений селекта  */
                    return { value: utoa(filter.value) };
                }
            }
            return filter;
        })
    }

    return response;
}
